// extracted by mini-css-extract-plugin
export default {"no-content-box":"NoConTent_no-content-box__g9lC2"};